export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'

export const competitionId = {
  DEV: 435,
  PDN: 481,
}[ENV]

export const LOCALE = process.env.LOCALE || 'es-CO'

export const costActivity = 30
export const costHelpActivity = 10
